export const reservationSummaryQueryKeys = {
    all: ['fetch-reservation-summaries'],
    list: (forEmail?: string) => [...reservationSummaryQueryKeys.all, 'list', forEmail] as const,
};
export const reservationDataQueryKeys = {
    all: ['fetch-reservation'],
    ref: (reservationReference?: string) => [...reservationDataQueryKeys.all, reservationReference] as const,
    data: (reservationReference?: string) => [...reservationDataQueryKeys.ref(reservationReference), 'data'] as const,
    booking: (reservationReference?: string) => [...reservationDataQueryKeys.ref(reservationReference), 'booking'] as const,
    preferences: (reservationReference?: string) => [...reservationDataQueryKeys.ref(reservationReference), 'preferences'] as const,
    documents: (reservationReference?: string) => [...reservationDataQueryKeys.ref(reservationReference), 'documents'] as const,
    signatures: (reservationReference?: string) => [...reservationDataQueryKeys.ref(reservationReference), 'signatures'] as const,
};
export const branchQueryKeys = {
    all: ['branch'],
    listByRegion: () => [...branchQueryKeys.all, 'by-region'] as const,
    branchContent: (branchCode?: string) => [...branchQueryKeys.all, 'branch-content', branchCode] as const,
    site: (branchCode?: string) => [...branchQueryKeys.all, 'site-data', branchCode] as const,
};
export const fleetCategoryContentQueryKeys = {
    all: ['fleet-category-content'],
    generation: (fleetCategoryCode?: string, countryCode?: string, generation?: string) =>
        [...fleetCategoryContentQueryKeys.all, fleetCategoryCode, countryCode, generation] as const,
};
export const paymentQueryKeys = {
    all: ['payment'],
    config: () => [...paymentQueryKeys.all, 'config'] as const,
};
